module.exports = __webpack_public_path__ + "static/media/Icn-apk.6e8b7394.svg";